module.exports = __webpack_public_path__ + "assets/img/dr-rafal-rzeszotarski.6c0ed680.jpg";